import { Directive, HostListener, Input, inject } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';

import { Link } from '../models/models';

@Directive({
    selector: '[paOpenLink]',
    standalone: true,
})
export class PaymentsOpenLinkDirective {
    private navigationService = inject(NavigationService);

    @Input('paOpenLink') link: Link = {};
    @Input('url') doNothing = false;

    @HostListener('click', ['$event'])
    async onClick() {
        if (this.doNothing) {
            return;
        }
        if (this.link.url) {
            let options = {};
            if (this.link.target) {
                options = { forceReloadTarget: this.link.target.replace('_', '') };
            }
            await this.navigationService.goTo(this.link.url, options);
        }
    }
}
//TODO: implement tracking logic here
